import { generatePath } from 'react-router-dom';

export const getRoutePath = (tenantId, caseType) =>
  generatePath('/:tenantId/case/:caseType', {
    tenantId: tenantId,
    caseType: caseType
  });

export const getNewRoutePath = tenantId =>
  generatePath('/:tenantId/case/new', {
    tenantId: tenantId
  });

export const getRootMunicipalityPath = tenantId =>
  generatePath('/:tenantId', {
    tenantId: tenantId
  });
